module.exports = __webpack_public_path__ + "static/img/pro_display_6.af87999.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productDisplay/pro_display_6.jpg
// module id = N6y8
// module chunks = 1